import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import CodeContent from './CodeContent';
import BasicTable from './Tabla';

function createData(
  campo,
  Tipo,
  valorEjemplo,
  Descripcion
) {
  return { campo, Tipo, valorEjemplo, Descripcion };
}

const ConsultaApiRuc = () => {
  const [t] = useTranslation('global');


  return (
    <div id='ConsultaApiRuc'>
      <Divider sx={{ height: '70px' }} />
      <Typography variant="h3" id="ApiRucQuery" gutterBottom>
        {t('content.ConsultaRuc.titulo')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('content.ConsultaRuc.subtituloConsultaRuc')}{' '}
        
      </Typography>
      <br/>
    </div>
  );
}
export default ConsultaApiRuc